/**
 * For performance
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleTimeString
 */
const datetimeWithoutSecondsFormat = new Intl.DateTimeFormat(undefined, {
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
	hour12: false,
});

export function formatDateTime(input: string | number | Date | null | undefined): string {
	if (!input) return '-';
	const d = new Date(input);
	if (Number.isNaN(d.getTime())) return '-';
	const parts = Object.fromEntries(
		datetimeWithoutSecondsFormat.formatToParts(d).map((p) => [p.type, p.value])
	);
	return `${parts.day}-${parts.month}-${parts.year}, ${parts.hour}:${parts.minute}`;
}

export { datetimeWithoutSecondsFormat };
